import React from 'react';
import styles from '../ResourceTriage.module.scss';
import { Typography } from '@mui/material';
import { Stack } from 'new/elements/Stack';
import {
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_RECORD_TRANSFORM,
  RESOURCE_TYPE_SCHEMA_SPECS,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import { ReactComponent as SourceIcon } from 'new/components/icons/fi-rr-exit.svg';
import { ReactComponent as LockAltIcon } from 'new/components/icons/lockAlt.svg';
import { ReactComponent as NexsetIcon } from 'new/components/icons/nexsetsOutline.svg';
import { ReactComponent as DestinationIcon } from 'new/components/icons/fi-rr-arrow-right-to-bracket.svg';
import { ReactComponent as FlowIcon } from 'new/components/icons/fi-rr-diagram-subtask.svg';
import { ReactComponent as SchemaTemplatesIcon } from 'new/components/icons/fi-rr-layout-fluid.svg';
import { ReactComponent as ReusableIcon } from 'new/components/icons/fi-rr-recycle.svg';
import { ReactComponent as LookupsIcon } from 'new/components/icons/table-lookup.svg';

interface ResourceTypeProps {
  type: string;
}

export const ResourceTypeData = {
  [RESOURCE_TYPE_SOURCE]: {
    icon: <SourceIcon />,
    label: 'Source',
  },
  [RESOURCE_TYPE_DATA_SET]: {
    icon: <NexsetIcon />,
    label: 'Nexset',
  },
  [RESOURCE_TYPE_SINK]: {
    icon: <DestinationIcon />,
    label: 'Destination',
  },
  [RESOURCE_TYPE_FLOW]: {
    icon: <FlowIcon />,
    label: 'Flow',
  },
  [RESOURCE_TYPE_CREDENTIALS]: {
    icon: <LockAltIcon />,
    label: 'Credential',
  },
  [RESOURCE_TYPE_SCHEMA_SPECS]: {
    icon: <SchemaTemplatesIcon />,
    label: 'Schema Template',
  },
  [RESOURCE_TYPE_RECORD_TRANSFORM]: {
    icon: <ReusableIcon />,
    label: 'Reusable Transform',
  },
  [RESOURCE_TYPE_DATA_MAP]: {
    icon: <LookupsIcon />,
    label: 'Lookup',
  },
};

export const ResourceType = (props: ResourceTypeProps) => {
  if (!props.type) {
    return null;
  }
  return (
    <Stack gap="4px" direction="row" alignItems="center" className={styles.resourceTypeContainer}>
      {ResourceTypeData[props.type]?.icon}
      <Typography variant="button2">{ResourceTypeData[props.type]?.label}</Typography>
    </Stack>
  );
};
